import React, { useEffect, useRef, useState } from 'react'
import { AccountAvatar, AccountSub, AccountTitle } from './account-view'
import { emailKey, forgetAccount, readRecentAccounts } from './recent-accounts'

// "Forget this account on this device" where a sign-out ends (owner
// 2026-10-25). The account menu has its own item (sidebar-right.js); this is
// /open/signed-out's, the page an app's sign-out lands on in the browser.
// That page can't tell which account signed out, so it offers each account
// this browser remembers: one account gets the full button, several get a
// Forget beside each. Nothing remembered: nothing shown.
export const ForgetAccountOffer = () => {
  const [accounts, updateAccounts] = useState(() => readRecentAccounts())
  // { text, n }: n moves on every forget, so the line takes focus (and is
  // read) again even when the words are the same.
  const [forgotten, updateForgotten] = useState({ text: '', n: 0 })
  const statusRef = useRef(null)

  useEffect(
    () => {
      if (forgotten.n && statusRef.current) statusRef.current.focus()
    },
    [forgotten]
  )

  if (!accounts.length && !forgotten.n) return null

  const handleForget = account => {
    updateAccounts(forgetAccount(account.email))
    updateForgotten(prev => ({ text: `${account.email} won't be suggested when you sign in on this device.`, n: prev.n + 1 }))
  }

  const single = accounts.length === 1

  return (
    <section className="sa-forget" aria-labelledby={accounts.length ? 'forget-title' : undefined} data-testid="forget-account-offer">
      {accounts.length > 0 &&
        <React.Fragment>
          <h2 id="forget-title" className="sa-chooser-heading">
            {single ? 'Remembered on this device' : 'Forget an account on this device'}
          </h2>

          <ul className="sa-options">
            {accounts.map(account =>
              <li key={emailKey(account.email)}>
                <div className="sa-option sa-account-edit">
                  <AccountAvatar account={account} />
                  <span className="sa-option-name">
                    <span className="sa-option-title">
                      <AccountTitle account={account} />
                    </span>
                    <span className="sa-option-sub">
                      <AccountSub account={account} />
                    </span>
                  </span>
                  {!single &&
                    <button type="button" className="btn sw-btn sa-account-forget" aria-label={`Forget ${account.email} on this device`} onClick={() => handleForget(account)}>
                      Forget
                    </button>}
                </div>
              </li>
            )}
          </ul>

          {single &&
            <button type="button" className="btn sw-btn sa-block" onClick={() => handleForget(accounts[0])}>
              Forget this account on this device
            </button>}
        </React.Fragment>}

      {/* Read when it takes focus; not a live region too, so it isn't read twice. */}
      <p ref={statusRef} className="sa-foot" tabIndex={-1} data-testid="forget-account-done">
        {forgotten.text}
      </p>
    </section>
  )
}
